import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AudioProvider } from "./audioContext";
import Hero from "./components/Hero";
import Home from "./components/Home";
import ListaInvitados from "./components/ListaInvitados";

function App() {
  return (
    <AudioProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/home" element={<Home />} />
          <Route path="/lista" element={<ListaInvitados />} />

        </Routes>
      </Router>
    </AudioProvider>
  );
}

export default App;